import { render, staticRenderFns } from "./AlertCaseDetailsContent.vue?vue&type=template&id=ca62c768&scoped=true"
import script from "./AlertCaseDetailsContent.vue?vue&type=script&lang=js"
export * from "./AlertCaseDetailsContent.vue?vue&type=script&lang=js"
import style0 from "./AlertCaseDetailsContent.vue?vue&type=style&index=0&id=ca62c768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca62c768",
  null
  
)

export default component.exports